import React from "react";
import { Spinner } from "react-bootstrap";

export function SpinnerComponent({ containerClasses = "" }) {
  return (
    <div className={containerClasses}>
      <Spinner animation="grow" variant="success" />
      <Spinner animation="grow" variant="danger" />
      <Spinner animation="grow" variant="warning" />
    </div>
  );
}
